
define('tpl!taoQtiItem/qtiCreator/tpl/toolbars/simpleChoice.content', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "";
  return buffer;
  }

function program3(depth0,data) {
  
  
  return "display:none;";
  }

function program5(depth0,data) {
  
  
  return "icon-pin";
  }

function program7(depth0,data) {
  
  
  return "icon-shuffle";
  }

  buffer += "<div class=\"mini-tlb\" data-edit=\"question\" data-for=\"";
  if (helper = helpers.serial) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.serial); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    <div class=\"rgt tlb-button\" title=\"Delete\" data-role=\"delete\">\n        <span class=\"icon-bin\"></span>\n    </div>\n    <div class=\"rgt tlb-button\" data-role=\"shuffle-pin\" title=\"Shuffle/Pin\" style=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.interactionShuffle), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n        <span class=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.fixed), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"></span>\n    </div>\n    <div class=\"rgt tlb-button\" data-role=\"cke-launcher\" title=\"Formatting options\">\n        <span class=\"icon-font\"></span>\n    </div>\n</div>";
  return buffer;
  });
});

